import { HIDDEN_RATE_PLAN_CLIENT_CODES } from "../constants/hiddenRatePlans";

// A rate plan is hidden when any of its exclusive demand clients is one of
// the placeholder "do not touch" clients. Both rate plan list APIs — the BE
// AppResponse (`BE/api/v1/rate-plans`) and the METADATA search
// (`METADATA/v2/metadata/rateplan/search`) — expose the clients as
// `exclusiveClients: [{ clientCode }]`.
export const isHiddenRatePlan = (ratePlan) =>
  Array.isArray(ratePlan?.exclusiveClients) &&
  ratePlan.exclusiveClients.some((client) =>
    HIDDEN_RATE_PLAN_CLIENT_CODES.includes(client?.clientCode)
  );

export const filterHiddenRatePlans = (ratePlans) =>
  Array.isArray(ratePlans)
    ? ratePlans.filter((ratePlan) => !isHiddenRatePlan(ratePlan))
    : ratePlans;

// Strips hidden rate plans from an axios response in place. `listKey` names
// the response-body field holding the list: "data" for the BE AppResponse
// envelope, "content" for METADATA's paginated search. Non-list bodies
// (error envelopes, nulls) pass through untouched.
export const stripHiddenRatePlansFromResponse = (response, listKey) => {
  const list = response?.data?.[listKey];
  if (Array.isArray(list)) {
    response.data[listKey] = filterHiddenRatePlans(list);
  }
  return response;
};
